export default "__VITE_ASSET__DHmU2VRA__"